import LayoutModal from "../Layout/LayoutModal";

import { ReactComponent as RightBracket } from "../Images/right_bracket.svg";
import { ReactComponent as IconCrossRound } from "../Images/icon_cross_round.svg";
import styled from "styled-components";
import "../Styles/global.css";
import RadioButton from "../Components/RadioButton";
import ProfileCard from "../Components/ProfileCard";
import { useState, useEffect } from "react";
import DepartmentManage from "./DepartmentManage";
import AlarmCancel from "./AlarmCancel";
import ToastAlarm from "../Components/ToastAlarm";
import { postJson } from "../Utils/apiUtils";

const SetNicknameBox = ({ handleClickBack, handleClickX }) => {
  const initialOption = Number(localStorage.getItem("departmentVisible"));

  const [selectedOption, setSelectedOption] = useState(initialOption);
  const [isDepartmentModalOpen, setIsDepartmentModalOpen] = useState(false);
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [modal, setModal] = useState(false);
  const [toast, setToast] = useState({
    show: false,
    type: "", // success, error
  });

  const handleOptionChange = (option) => {
    setSelectedOption(option);

    if (selectedOption !== option) {
      setIsButtonEnabled(true);
    }
  };

  useEffect(() => {
    if (selectedOption === initialOption) {
      setIsButtonEnabled(false);
    }
  }, [selectedOption]);

  const handleOpenDepartmentModal = () => {
    setIsDepartmentModalOpen(true);
  };

  const handleCloseDepartmentModal = () => {
    setIsDepartmentModalOpen(false);
  };

  const handleOpenModal = () => {
    setModal(true);
  };

  const handleClickUpdateNickname = async () => {
    try {
      const body = { isDepartmentVisible: selectedOption };
      const res = await postJson(
        "/dashboard/company/updateDepartmentVisible",
        body
      );

      if (res.code === 200) {
        localStorage.setItem("departmentVisible", selectedOption);
        setModal(false);
        setToast({ show: true, type: "success" });
      }
    } catch (error) {
      console.error("앱 닉네임 표기 방식 설정 중 오류");
      setModal(false);
      setToast({ show: true, type: "error" });
    }
  };

  return (
    <>
      {toast.show && (
        <div
          className="page-wrapper center"
          style={{
            backgroundColor: "transparent",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 100,
          }}
        >
          {toast.type === "success" && (
            <ToastAlarm
              message={"변경사항이 저장되었습니다."}
              setToast={setToast}
              type={"success"}
            />
          )}
          {toast.type === "error" && (
            <ToastAlarm
              message={"다시 한번 시도해주세요."}
              setToast={setToast}
              type={"error"}
            />
          )}
        </div>
      )}
      <Box>
        <div>
          <div className="hrz-wrapper">
            <RightBracket
              stroke="#b0b0b0"
              width="32px"
              height="32px"
              style={{ transform: "rotate(180deg)", cursor: "pointer" }}
              onClick={handleClickBack}
            />
            <p className="bold-text" style={{ fontSize: "24px" }}>
              앱 닉네임 표기 방식 설정
            </p>
            <IconCrossRound
              style={{ marginLeft: "auto", cursor: "pointer" }}
              onClick={handleClickX}
            />
          </div>

          <div>
            <p
              className="bold-text"
              style={{ fontSize: "18px", marginTop: "30px" }}
            >
              유저의 기업모드 닉네임을 어떻게 표시할까요?
            </p>
            <p
              className="hrz-wrapper"
              style={{ color: "#676767", marginTop: "10px" }}
            >
              선택값에 상관없이 '구성원 관리'페이지에서 부서를 등록하고,
              <br />
              유저의 부서정보를 확인할 수 있어요.
            </p>
          </div>

          <ContentLayout>
            <RadioButton
              option1={"닉네임만 표시"}
              option2={"부서+닉네임으로 표시"}
              selectedOption={selectedOption}
              optionChange={handleOptionChange}
            />
            {selectedOption === 0 && <ProfileCard nickname={"홍길동"} />}
            {selectedOption === 1 && (
              <ProfileCard department={"개발팀"} nickname={"홍길동"} />
            )}
          </ContentLayout>

          <DepartmentManageBtn onClick={handleOpenDepartmentModal}>
            <p className="hrz-wrapper">부서 관리 바로가기</p>
            <RightBracket stroke="#b0b0b0" style={{ marginTop: "0.2px" }} />
          </DepartmentManageBtn>
        </div>

        <div
          className="blueBtn-base center"
          style={{
            width: "500px",
            height: "56px",
            borderRadius: "10px",
            backgroundColor: isButtonEnabled ? "#1E4FFF" : "#b0b0b0",
          }}
          onClick={isButtonEnabled ? handleOpenModal : null}
        >
          저장하기
        </div>
      </Box>
      {isDepartmentModalOpen && (
        <DepartmentManage
          handleCloseDepartmentModal={handleCloseDepartmentModal}
        />
      )}
      {modal && (
        <AlarmCancel
          title={"변경사항을 저장하시겠습니까?"}
          subtitle={`저장 시 변경한 내용이\n기업 구성원의 앱 화면에 반영됩니다.`}
          handleClickX={() => setModal(false)}
          handleCancel={handleClickUpdateNickname}
        />
      )}
    </>
  );
};

const Box = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: auto;
  height: 646px;
  padding: 30px;
  border-radius: 20px;
  background-color: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
`;

const ContentLayout = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 30px;
  margin-top: 30px;
  padding: 24px 88.5px;
  border-radius: 20px;
  background: #f9f9f9;
`;

const DepartmentManageBtn = styled.div`
  display: flex;
  margin-top: 20px;
  justify-content: end;
  align-items: center;
  gap: 4px;
  cursor: pointer;
`;

const SetNickname = ({ handleClickBack, handleClickX }) => {
  return (
    <LayoutModal
      Modal={
        <SetNicknameBox
          handleClickBack={handleClickBack}
          handleClickX={handleClickX}
        />
      }
    />
  );
};

export default SetNickname;
